module.exports = __webpack_public_path__ + "img/96.67981870.jpg";